import { CurrencyCode } from 'further-types/lp/vehicle';
import FormWrapper, { EqualisationInterestFormValues } from './FormWrapper';
import EqualisationInterestContent from './EqualisationInterestContent';
import { EqualisationSection } from 'further-types/lp/equalisation';
import { useParams } from 'react-router-dom';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';

const EqualisationInterest: React.FC<{ baseCurrency: CurrencyCode }> = ({
  baseCurrency,
}) => {
  const { id } = useParams<{ id?: string }>();
  const { selectedVehicleId } = useLayoutContext();
  const [equalisationInterest] = api.equalisations.getInterest.useSuspenseQuery(
    {
      equalisationId: id ?? '',
      vehicleId: selectedVehicleId ?? '',
    },
  );

  const formValues: EqualisationInterestFormValues = {
    equalisationInterestPaymentBreakdown:
      equalisationInterest.netEqualisationInterestPaymentBreakdown.map(
        (item) => {
          const savedItem =
            equalisationInterest.savedEqualisationInterestPaymentBreakdown.find(
              (savedItem) => savedItem.commitmentId === item.commitmentId,
            );

          return {
            ...item,
            excludeFromEqualisationInterest:
              savedItem?.excludeFromEqualisationInterest ?? false,
            equalisationInterestTotalLcy:
              savedItem?.equalisationInterestTotalLcy ??
              item.equalisationInterestTotalLcy,
          };
        },
      ),
  };

  return (
    <FormWrapper
      key={EqualisationSection.EqualisationInterest}
      values={formValues}
    >
      <EqualisationInterestContent
        baseCurrency={baseCurrency}
        calculationBreakdown={equalisationInterest.calculationBreakdown}
      />
    </FormWrapper>
  );
};

export default EqualisationInterest;
